export const APP_TIME_ZONE = 'America/Sao_Paulo';

const pad = (value) => String(value).padStart(2, '0');

const getAppDateParts = (dateValue = new Date()) => {
  const date = dateValue instanceof Date ? dateValue : new Date(dateValue);
  if (Number.isNaN(date.getTime())) return null;
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: APP_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
    hour12: false
  }).formatToParts(date);
  return Object.fromEntries(parts.filter((part) => part.type !== 'literal').map((part) => [part.type, part.value]));
};

export const appTodayDate = () => {
  const parts = getAppDateParts();
  return parts ? `${parts.year}-${parts.month}-${parts.day}` : '';
};

export const appNowTime = () => {
  const parts = getAppDateParts();
  return parts ? `${parts.hour}:${parts.minute}` : '';
};

export const toAppDateInputValue = (dateValue = new Date()) => {
  const parts = getAppDateParts(dateValue);
  return parts ? `${parts.year}-${parts.month}-${parts.day}` : '';
};

export const toAppTimeInputValue = (dateValue = new Date()) => {
  const parts = getAppDateParts(dateValue);
  return parts ? `${parts.hour}:${parts.minute}` : '';
};

export const buildAppDateTimeIso = (dateValue, timeValue = '00:00') => {
  if (!dateValue) return null;
  const [year, month, day] = String(dateValue).split('-').map(Number);
  const [hour = 0, minute = 0] = String(timeValue || '00:00').split(':').map(Number);
  if (![year, month, day, hour, minute].every(Number.isFinite)) return null;
  const localDate = new Date(year, month - 1, day, hour, minute);
  return localDate.toISOString();
};

export const formatAppDate = (dateValue) => {
  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString('pt-BR', { timeZone: APP_TIME_ZONE });
};

export const formatAppDateTime = (dateValue) => {
  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleString('pt-BR', { timeZone: APP_TIME_ZONE });
};

export const createClientRequestId = (prefix = 'req') => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return `${prefix}-${crypto.randomUUID()}`;
  return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2)}`;
};
